
import VacationsPanel from '@/requests/vacations/views/user/page';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/requests/$id/vacations/')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }
  },
  component: UserVacationsList,
});

function UserVacationsList() {
  const { id } = Route.useParams();

  return (
    <div className="container mx-auto py-6">
      <VacationsPanel userId={id} />
    </div>
  );
}